/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import moment from 'moment';
import RiskProfileIcons from '../../../View/templates/components/risk/riskProfileIcons';
import PeriodWidget from '../../components/scl-components/period-widget';
import { selectFilterSearch } from '../../../../helpers/StringHelper';
import Style from './style';
import { mapData } from './config';
import { getPopupContainer } from '../../../../helpers/popUp';

const RiskCategories = ({ data = {}, loading }) => {
  const { t } = useTranslation();
  const [profileData, setProfileData] = useState(mapData());
  const [baseline, setBaseline] = useState();
  const [comparison, setComparison] = useState();
  const [versions, setVersions] = useState([]);

  const initData = () => {
    const versions = JSON.parse(JSON.stringify(data || {}));
    if (typeof versions === 'object') {
      const versionsValues = Object.entries(versions).map(([k, v]) => ({
        value: k,
        date: v.date,
      }));
      setVersions(versionsValues);
      if (versionsValues.length) {
        if (versionsValues.length > 1) {
          setBaseline(versionsValues[0].value);
          setComparison(versionsValues[versionsValues.length - 1].value);
        } else {
          setBaseline(versionsValues[0].value);
          setComparison(null);
        }
      } else {
        setComparison(null);
        setBaseline(null);
      }
    }
  }

  useEffect(() => {
    if (typeof data === 'object') {
      initData();
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      const vers = JSON.parse(JSON.stringify(data || {}));;
      setProfileData(mapData(vers[baseline], vers[comparison], t));
    }
  }, [baseline, comparison]);

  return (
    <PeriodWidget
      title={t('Risk Categories')}
      loading={loading}
      className="custom-width-d with-border-header no-pt-body"
    >
      <Style>
        {profileData && (
          <RiskProfileIcons
            data={profileData}
            className="custom-width-b"
            defaultFields={['Comparison', 'Baseline']}
          />
        )}
      </Style>
      <div className="filters"
        style={{ justifyContent: 'center' }}
      >
        <div className="item">
          <div className="cont">
            <div className="legend" style={{ background: '#37C3AA' }} />
          </div>
          <div className="cont">
            <label>{t('Baseline')}</label>
          </div>
          <Select
            {...getPopupContainer()}
            value={baseline}
            onChange={(v) => setBaseline(v)}
            showSearch
            filterOption={selectFilterSearch}
          >
            {(versions || []).filter((v) => v.value !== comparison).map((b) => (
              <Select.Option
                value={b.value}
                key={`baselines-${b.value}`}
              >
                {t('Version')}
                {' '}
                {b.value}
                {b.date ? ` - ${moment(b.date).format('DD MMM YYYY')}` : null}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="item">
          <div className="cont">
            <div className="legend" style={{ background: 'var(--color-primary-70)' }} />
          </div>
          <div className="cont">
            <label>{t('Comparison')}</label>
          </div>
          <Select
            {...getPopupContainer()}
            value={comparison}
            onChange={(v) => setComparison(v)}
            showSearch
            filterOption={selectFilterSearch}
          >
            {(versions || []).filter((v) => v.value !== baseline).map((b) => (
              <Select.Option
                value={b.value}
                key={`comparisons-${b.value}`}
              >
                {t('Version')}
                {' '}
                {b.value}
                {b.date ? ` - ${moment(b.date).format('DD MMM YYYY')}` : null}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    </PeriodWidget>
  );
};

export default RiskCategories;
